function getPhone(obj, withCountryCode = false) {
  if (!isAnPhoneObject(obj)) return;
  const number = obj.area_code + obj.number;
  return withCountryCode ? obj.country_code + number : number;
}

function isAnPhoneObject(obj) {
  const itsAnObject = typeof obj === "object";
  const haveValidAttributes = obj.area_code && obj.country_code && obj.number;
  return itsAnObject && haveValidAttributes;
}

function createPhoneObject(number) {
  const country_code = "55";
  const area_code = number.substr(0, 2);
  number = number.substr(2, number.length);

  return {
    country_code,
    area_code,
    number
  };
}

export default {
  getPhone,
  createPhoneObject
};



// WEBPACK FOOTER //
// ./src/utils/formatters/phones.js